import { render } from "./item.vue?vue&type=template&id=625938f0&scoped=true&ts=true"
import script from "./item.vue?vue&type=script&lang=ts"
export * from "./item.vue?vue&type=script&lang=ts"

import "./item.vue?vue&type=style&index=0&id=625938f0&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-625938f0"]])

export default __exports__